/**
 * 객체 설정 > 주소 객체 Store
 *
 * @since 2018-06-14
 * @author kdydesign.kim
 */

// TAMS
import {ObjectSecProfileApiPrefix as objApiPrefix, SystemApiPrefix as smApiPrefix, CmApiPrefix as cmApiPrefix} from 'utils'
// utils
import {
  computedGetDomainData,
  computedGetNetworkData,
  computedSetNetworkData,
  getAddrObjType,
  getAddrVersion,
  objectSetDataParser,
  // TAMS
  parseAddrObjectTypeNumber,
  parseAddrObjectIpVersionType
} from 'objectSettingsUtils'

import {i18n} from '~/plugins/i18n'
// 호스트 객체 데이터
const hostData = (zone) => {
  return {
    addr_obj_uname: void 0,
    addr_obj_zone_type: zone !== void 0 ? zone : 1,
    addr_obj_desc: void 0,
    addr_obj_ip_exp: null,
    cfg_layer: 1
  }
}
// 네트워크 객체 데이터
const networkData = (zone) => {
  return {
    addr_obj_uname: void 0,
    addr_obj_zone_type: zone !== void 0 ? zone : 1,
    addr_obj_type: 2,
    ipRange: { ip1: null, ip2: null },
    ipAddress: { ip: null, netmask: null },
    addr_obj_desc: void 0,
    cfg_layer: 1
  }
}
// 도메인 객체 데이터
const domainData = (zone) => {
  return {
    addr_obj_uname: void 0,
    domain_name: void 0,
    addr_obj_zone_type: zone !== void 0 ? zone : 1,
    fullIpv4: [],
    fullIpv6: [],
    ipv4_ori: [],
    ipv4: [],
    ipv6_ori: [],
    ipv6: [],
    addr_obj_desc: void 0,
    cfg_layer: 1
  }
}
// 그룹 객체 데이터
const groupData = () => {
  return {
    addr_obj_id: 1,
    name: void 0,
    zone: 1,
    addr_obj_type: 4,
    mmbr_obj: [],
    desc: void 0
  }
}
// 사용자 객체 데이터
const userData = () => {
  return {
    type: 1,
    dmn: void 0,
    login_id: void 0,
    login_pw: void 0,
    auth_type: 1,
    name: void 0,
    depart: void 0,
    email: void 0,
    phone: void 0,
    desc: void 0
  }
}
// 사용자 객체 - IP 매핑 서버 데이터
const userIpMappingServerData = () => {
  return {
    serv_name: void 0,
    serv_type: 1,
    auth_serv_id: 1,
    usr_obj_class: 'person',
    usr_id_attr: 'uid',
    usr_name_attr: 'userName',
    usr_depart_attr: 'userDepartment',
    usr_ip_attr: 'ipHostNumber',
    auto_sched: 7
  }
}
// 사용자 객체 - 사용자 그룹 객체 데이터
const userGroupData = () => {
  return {
    grp_dmn: void 0,
    grp_name: void 0,
    grp_desc: void 0,
    usr_obj_ids: []
  }
}
// 사용자 객체 - IP 매핑 사용자 데이터
const userIpMappingData = () => {
  return { mmbr_obj: [] }
}
// 디바이스 객체 데이터
const deviceData = () => {
  return {
    dvc_alias: void 0,
    dvc_key: void 0,
    usr_id: void 0,
    dvc_os_vers: void 0,
    dvc_os_type: 1,
    dvc_stat: 0,
    clnt_ver: void 0,
    dvc_send_msg: void 0,
    dvc_last_alive: void 0,
    dvc_last_modify: void 0,
    dvc_ip: []
  }
}
const initInfo = () => {
  return {
    type: 0,
    name: '',
    ver: ''
  }
}
const initDeviceInfo = () => {
  return {
    os: initInfo(),
    security: [],
    program: [],
    custom: []
  }
}
export const state = () => ({
  selectedData: [],
  hostData: hostData(),
  networkData: networkData(),
  domainData: domainData(),
  groupData: groupData(),
  userData: userData(),
  userIpMappingServerData: userIpMappingServerData(),
  userIpMappingData: userIpMappingData(),
  deviceData: deviceData(),
  userGroupData: userGroupData(),
  addressObjectDataList: [],
  ipMappingNewUserAllList: [],
  userDomainList: [],
  copyData: void 0,
  deviceInfo: initDeviceInfo(),
  parentMenu: '' // SSL 정책설정 메뉴에서 직접입력시 메뉴명 추가할때 사용
})
export const mutations = {
  // 실행되는 메뉴 설정
  setParentMenu (state, data) {
    state.parentMenu = data
  },
  // zone 설정
  setZone (state, data) {
    state.hostData.addr_obj_zone_type = data
    state.networkData.addr_obj_zone_type = data
    state.domainData.addr_obj_zone_type = data
  },
  resetAddressCopyData (state) {
    state.copyData = void 0
  },
  // 선택한 데이터 초기화
  resetAddressObjectData (state) {
    state.selectedData = void 0
  },
  // 주소 객체 선택
  selectAddressObjectData (state, data) {
    state.selectedData = data
  },
  // 주소 객체 초기화
  resetAddressObjData (state, data) {
    state.hostData = hostData(data)
    state.networkData = networkData(data)
    state.domainData = domainData(data)
    state.userData = userData()
    state.userIpMappingServerData = userIpMappingServerData()
    state.deviceData = deviceData()
    state.userGroupData = userGroupData()
    state.ipMappingNewUserAllList = []
  },
  // 주소 객체 목록 조회
  getAddressObjDataList (state, data) {
    state.addressObjectDataList = Object.freeze(_.map(data, (obj) => {
      return objectSetDataParser(obj)
    }))
    data = Object.freeze(data)
  },
  // 주소 객체 목록 초기화
  resetAddressObjDataList (state) {
    state.addressObjectDataList = []
  },
  // 주소 객체 삭제
  deleteAddressObjData (state, {objectId, addrType, rootState}) {
    const objectList = rootState.cm.objectSecProfile.object.objectSettings.common.objectList
    const addressObjectDataList = _.cloneDeep(state.addressObjectDataList)
    let itemIndex = _.findIndex(state.addressObjectDataList, {addr_obj_id: objectId})
    if (addrType === 'device') {
      itemIndex = _.findIndex(state.addressObjectDataList, {dvc_obj_id: objectId})
    }
    if (addrType === 'user') {
      itemIndex = _.findIndex(state.addressObjectDataList, {usr_obj_id: objectId})
    }
    if (addrType === 'ipMappingServer') {
      const selectTarget = rootState.cm.objectSecProfile.object.objectSettings.common.selectTarget
      if (selectTarget === 'ipMappingServer') {
        const addressObject = _.find(objectList, (o) => { return o.key === 'address' })
        const ipMappingNode = _(addressObject.children).map('children').value()[4]
        const ipMappingNodeChildrenIndex = _.findIndex(_(ipMappingNode).map('children').value())
        const ipMappingNodeList = _(ipMappingNode).map('children').value()
        const targetCildrenNode = ipMappingNodeList[ipMappingNodeChildrenIndex]
        const treeNode = _(ipMappingNode).map('children').flatten().filter({
          key: `address.user.ipMapping.${objectId}`
        }).value()[0]
        if (treeNode) {
          const deleteNodeIndex = _.findIndex(targetCildrenNode, treeNode)
          targetCildrenNode.splice(deleteNodeIndex, 1)
        }
        itemIndex = _.findIndex(state.addressObjectDataList, {ip_map_svr_id: objectId})
      } else {
        itemIndex = _.findIndex(state.addressObjectDataList, {ip_map_usr_id: objectId})
      }
    }
    addressObjectDataList.splice(itemIndex, 1)
    state.addressObjectDataList = Object.freeze(addressObjectDataList)
  },
  // 주소 객체 일괄 삭제
  deleteBatchAddressObjData (state, {items, addrType, rootState}) {
    const objectList = rootState.cm.objectSecProfile.object.objectSettings.common.objectList
    const addressObjectDataList = _.cloneDeep(state.addressObjectDataList)
    _.forEach(items, (o) => {
      let itemIndex = _.findIndex(addressObjectDataList, {addr_obj_id: o.addr_obj_id})
      if (addrType === 'device') itemIndex = _.findIndex(addressObjectDataList, {dvc_obj_id: o.dvc_obj_id})
      if (addrType === 'user') itemIndex = _.findIndex(addressObjectDataList, {usr_obj_id: o.usr_obj_id})
      if (addrType === 'ipMappingServer') {
        const selectTarget = rootState.cm.objectSecProfile.object.objectSettings.common.selectTarget
        if (selectTarget === 'ipMappingServer') {
          const addressObject = _.find(objectList, (o) => { return o.key === 'address' })
          const ipMappingNode = _(addressObject.children).map('children').value()[4]
          const ipMappingNodeChildrenIndex = _.findIndex(_(ipMappingNode).map('children').value())
          const ipMappingNodeList = _(ipMappingNode).map('children').value()
          const targetCildrenNode = ipMappingNodeList[ipMappingNodeChildrenIndex]
          const treeNode = _(ipMappingNode).map('children').flatten().filter({
            key: `address.user.ipMapping.${o.ip_map_svr_id}`
          }).value()[0]
          if (treeNode) {
            const deleteNodeIndex = _.findIndex(targetCildrenNode, treeNode)
            targetCildrenNode.splice(deleteNodeIndex, 1)
          }
          itemIndex = _.findIndex(addressObjectDataList, {ip_map_svr_id: o.ip_map_svr_id})
        } else {
          itemIndex = _.findIndex(addressObjectDataList, {ip_map_usr_id: o.ip_map_usr_id})
        }
      }
      addressObjectDataList.splice(itemIndex, 1)
    })
    state.addressObjectDataList = Object.freeze(addressObjectDataList)
  },
  // 주소 객체 조회
  getAddressObjData (state, {result, addrType}) {
    result = result[0]
    if (addrType.indexOf('host') > -1) state.hostData = result
    if (addrType.indexOf('network') > -1) state.networkData = computedGetNetworkData(result)
    if (addrType.indexOf('domain') > -1) state.domainData = computedGetDomainData(result)
    if (addrType.indexOf('device') > -1) state.deviceData = result
    if (addrType.indexOf('address.user.user') > -1) {
      state.userData = _.assign(result, { login_pw: void 0 })
    }
    if (addrType.indexOf('address.user.ipMapping') > -1) state.userIpMappingServerData = result
    if (addrType.indexOf('group') > -1) state.groupData = result
  },
  // 주소 객체 저장
  saveAddressObjData (state, {result, objectType}) {
    const addressObjectDataList = _.cloneDeep(state.addressObjectDataList)
    if (/^address\.(host\.(4|6)|network\.(4|6)|domain)$/.test(objectType)) {
      addressObjectDataList.unshift(objectSetDataParser(result))
    } else if (/in/.test(objectType) && result.zone === 1) {
      addressObjectDataList.unshift(objectSetDataParser(result))
    } else if (/out/.test(objectType) && result.zone === 2) {
      addressObjectDataList.unshift(objectSetDataParser(result))
    } else if (/dmz/.test(objectType) && result.zone === 3) {
      addressObjectDataList.unshift(objectSetDataParser(result))
    } else if (!/(\.in|\.out|\.dmz)/.test(objectType)) {
      addressObjectDataList.unshift(objectSetDataParser(result))
    }
    state.addressObjectDataList = Object.freeze(addressObjectDataList)
  },
  // 주소 객체: 네트워크 객체 초기화
  resetNetworkIpData (state) {
    state.networkData.ipRange = { ip1: null, ip2: null }
    state.networkData.ipAddress = { ip: null, netmask: null }
  },
  // 도메인 객체 서브 도메인 추가
  addSubDomain (state, isSubDomain) {
    let parseUrlAddr = null
    const urlAddr = state.domainData.domain_name
    if (isSubDomain) {
      if (urlAddr) parseUrlAddr = `*.${urlAddr}`
    } else {
      parseUrlAddr = _.replace(urlAddr, '*.', '')
    }
    state.domainData.domain_name = parseUrlAddr
  },
  // 도메인 객체 - 서브 도메인 변경
  changeSubDomain (state, data) {
    state.domainData.domain_name = data
  },
  // 도메인 객체 ipv4/ipv6 추가
  addDomainIpData (state, {ip, ipType}) {
    if (ip === '' || _.indexOf(state.domainData[ipType], ip) !== -1) return
    state.domainData[ipType].push(ip)
    state.domainData[`full${_.capitalize(ipType)}`].push(ip)
  },
  // 도메인 객체 ipv4/ipv6 편집 시 추가
  updateDomainIpData (state, {ip, ipType}) {
    state.domainData[`${ipType}`].push(ip)
    state.domainData[`full${_.capitalize(ipType)}`].push(ip)
  },
  // 도메인 객체 ipv4/ipv6 삭제
  removeDomainIpData (state, {ip, ipType}) {
    const ipData = state.domainData[ipType]
    const fullIpData = state.domainData[`full${_.capitalize(ipType)}`]
    const index = _.indexOf(ipData, ip)
    const fullIndex = _.indexOf(fullIpData, ip)
    ipData.splice(index, 1)
    fullIpData.splice(fullIndex, 1)
  },
  // address 객체 복사
  copyAddressObjectData (state, {objectType}) {
    const selectedData = _.cloneDeep(state.selectedData)
    const keys = _.keys(selectedData)
    let data = null
    if (objectType.indexOf('network') > -1) {
      state.copyData = computedGetNetworkData(selectedData)
      return
    }
    if (objectType.indexOf('domain') > -1) {
      state.copyData = computedGetDomainData(selectedData)
      return
    }
    if (objectType.indexOf('host') > -1) { data = hostData() }
    if (objectType.indexOf('user.user') > -1) { data = userData() }
    _.each(keys, (key) => {
      if (_.has(data, key)) data[key] = selectedData[key]
    })
    state.copyData = data
  },
  // address 객체 붙여넣기
  pasteAddressObjectData (state, {objectType}) {
    const data = _.cloneDeep(state.copyData)
    if (objectType.indexOf('network') > -1) {
      state.networkData = data
    } else if (objectType.indexOf('domain') > -1) {
      state.domainData = data
    } else if (objectType.indexOf('host') > -1) {
      state.hostData = data
    } else if (objectType.indexOf('user.user') > -1) {
      state.userData = data
    }
  },
  // 도메인 이름과 도메인 객체 이름 동기화
  updateDomainObjName (state) {
    state.domainData.addr_obj_uname = state.domainData.domain_name
  },
  // 사용자 객체 - 인증 DB 변경에 따른 초기화
  changeUserObjType (state, value) {
    if (value === 1) {
      state.userData.dmn = void 0
    } else {
      state.userData.login_pw = void 0
      state.userData.auth_type = 1
    }
  },
  // 사용자 객체 - 인증 DB 변경
  changeUserType (state, value) {
    state.userData.type = value
  },
  // 사용자 객체 - 도메인 변경
  changeUserDomain (state, dmn) {
    state.userData.dmn = dmn
  },
  // 사용자 객체 - 도메인 목록 저장
  setUserDomain (state, data) {
    state.userDomainList = data
  },
  // 사용자 객체 - IP 매핑 서버 조회 후 첫 번째 서버로 설정
  changeAuthServId (state, {result, serverType}) {
    // LDAP
    if (serverType === 1) state.userIpMappingServerData.auth_serv_id = result[0].authsvr_ldap_id
    // MS-SQL
    if (serverType === 2) state.userIpMappingServerData.auth_serv_id = _.filter(result, {type: 1})[0].authsvr_extdb_id
  },
  // 사용자 객체 - IP Mapping 서버 추가
  setIpMappingServer (state, {result, rootState}) {
    const objectList = rootState.cm.objectSecProfile.object.objectSettings.common.objectList
    const addressObject = _.find(objectList, (o) => { return o.key === 'address' })
    const treeNode = _(addressObject.children)
      .map('children')
      .flatten()
      .filter({key: 'address.user.ipMapping'})
      .value()[0]
      .children
    if (treeNode) {
      const ipMappingServerId = _.find(treeNode, {key: `address.user.ipMapping.${result.ip_map_svr_id}`})
      if (!ipMappingServerId) {
        treeNode.push({
          label: result.serv_name,
          key: `address.user.ipMapping.${result.ip_map_svr_id}`,
          img: require('~/assets/img/icon/ico_ipUserServer_d.png')
        })
      }
    }
  },
  // IP 매핑 사용자 - 신규 사용자 Import 목록 조회
  getIpMappingUserList (state, data) {
    const ipMappingNewUserAllList = _.map(data, (o) => {
      return _.assign(o, { use: 0, desc: 'Auto Imported' })
    })
    state.ipMappingNewUserAllList = Object.freeze(ipMappingNewUserAllList)
  },
  // IP 매핑 사용자 - 신규 사용자 사용 데이터 설정
  setIpMappingUserData (state, {use, item}) {
    if (use === 1) {
      const itemIndex = _.findIndex(state.userIpMappingData.mmbr_obj, {usr_id: item.usr_id})
      if (itemIndex !== -1) return
      state.userIpMappingData.mmbr_obj.push({
        usr_id: item.usr_id,
        usr_name: item.usr_name,
        usr_depart: item.usr_depart,
        desc: item.desc
      })
    } else {
      const itemIndex = _.findIndex(state.userIpMappingData.mmbr_obj, {usr_id: item.usr_id})
      state.userIpMappingData.mmbr_obj.splice(itemIndex, 1)
    }
  },
  // IP 매핑 사용자 - 신규 사용자 전체 사용 데이터 설정
  setIpMappingAllUserData (state, data) {
    if (data === 1) {
      state.userIpMappingData.mmbr_obj = []
      _.each(state.ipMappingNewUserAllList, (o) => {
        state.userIpMappingData.mmbr_obj.push(_.pick(o, ['usr_id', 'usr_name', 'usr_depart', 'desc']))
      })
      state.ipMappingNewUserAllList = _.map(state.ipMappingNewUserAllList, (o) => {
        return _.assign(o, { use: 1 })
      })
    } else {
      state.userIpMappingData.mmbr_obj = []
      state.ipMappingNewUserAllList = _.map(state.ipMappingNewUserAllList, (o) => {
        return _.assign(o, { use: 0 })
      })
    }
  },
  // 사용자 객체 - 신규 사용자 Import 사용자 추가
  saveIpMappingUser (state, data) {
    state.addressObjectDataList = Object.freeze(data)
  },
  // 사용자 객체 - 방화벽에서 신규 사용자 Import 객체 추가
  saveFwIpMappingUser (state, {result, uniqData}) {
    const addressObjectDataList = _.cloneDeep(state.addressObjectDataList)
    const filterData = []
    _.forEach(result, (r) => {
      _.forEach(uniqData, (u) => {
        if (r.usr_id === u.usr_id) filterData.push(r)
      })
    })
    _.forEach(filterData, (o) => { addressObjectDataList.push(objectSetDataParser(o)) })
    state.addressObjectDataList = Object.freeze(addressObjectDataList)
  },
  // 사용자 객체 - 신규 사용자 Import 사용자 데이터 초기화
  resetIpMappingUserData (state) {
    state.userIpMappingData.mmbr_obj = []
  },
  // 사용자 객체 - 신규 사용자 Import 사용자 전체 데이터 초기화
  resetIpMappingNewUserAllList (state) {
    state.ipMappingNewUserAllList = []
  },
  // 사용자 객체 - 신규 사용자 Import 사용자 데이터 수정(설명 속성)
  updateNewImportIpMappingUserData (state, {value, item}) {
    if (state.userIpMappingData.mmbr_obj.length > 0) {
      _.map(state.userIpMappingData.mmbr_obj, (o) => {
        if (o.usr_id === item.usr_id) o.desc = value
      })
    }
  },
  // 사용자 객체 - IP 매핑 사용자 설명 데이터 수정
  updateIpMappingUserData (state, data) {
    const addressObjectDataList = _.map(state.addressObjectDataList, (o) => {
      if (o.ip_map_usr_id === data.ip_map_usr_id) o.desc = data.desc
      return o
    })
    state.addressObjectDataList = Object.freeze(addressObjectDataList)
  },
  setDeviceInfo (state, data) {
    state.deviceInfo = data
  },
  resetDeviceInfo (state) {
    state.deviceInfo = initDeviceInfo()
  },
  setUserDataAuthType (state, data) {
    state.userData.auth_type = data
  }
}
export const actions = {
  // 실행되는 메뉴 설정
  async setParentMenu ({commit, state}, data) {
    commit('setParentMenu', data)
  },
  // 주소 객체 초기화
  resetAddressObjData ({commit, rootState}) {
    const globalZone = rootState.cm.objectSecProfile.object.objectSettings.common.globalZone
    commit('resetAddressObjData', globalZone)
  },
  // 주소 객체 목록 조회 (객체 설정을 제외한 타 기능에서 사용)
  async getAddressObjDataList ({commit, dispatch, state}, {addrType, version, zone, target, userParams, loadingShow = true, loadingHide = true, isOkReturn = false} = {}) {
    let uri = ''
    const addrObjType = parseAddrObjectTypeNumber(addrType), // 주소 객체 유형, 1 호스트 객체, 2 네트워크 객체 (넷마스크), 3 네트워크 객체 (범위), 4 그룹 객체, 5 도메인 객체, 6 URI 객체 [1,2,3,4,5,6]
      addrObjIpVerType = parseAddrObjectIpVersionType(version, addrType), // 주소 객체 아이피 버전 유형 1 IPv4, 2 IPv6, 3 공통
      zoneType = zone === null ? 0 : zone // 존 0: 전체 조회, 1: 내부망, 2: 외부망, 3: DMZ
    uri = `${cmApiPrefix}/objects/addr/rules/${addrObjType}/${addrObjIpVerType}/${zoneType}`
    const {code, result} = await this.$axios.$get(uri, {loadingShow, loadingHide})
    if (code === 'ok') {
      if (isOkReturn) return result
      if (target !== 'group') commit('getAddressObjDataList', result)
      else commit('cm/objectSecProfile/object/objectSettings/groupObject/parseAddressObjDataList', result, {root: true})
    }
  },
  // 주소 객체 목록 조회 (객체 설정에서 사용)
  async getAddressObjDataListWithUsedFlag ({commit, dispatch, state}, {addrType, version, zone, target, userParams, loadingShow = true, loadingHide = true, isOkReturn = false} = {}) {
    let uri = ''
    const addrObjType = parseAddrObjectTypeNumber(addrType), // 주소 객체 유형, 1 호스트 객체, 2 네트워크 객체 (넷마스크), 3 네트워크 객체 (범위), 4 그룹 객체, 5 도메인 객체, 6 URI 객체 [1,2,3,4,5,6]
      addrObjIpVerType = parseAddrObjectIpVersionType(version, addrType), // 주소 객체 아이피 버전 유형 1 IPv4, 2 IPv6, 3 공통
      zoneType = zone === null ? 0 : zone // 존 0: 전체 조회, 1: 내부망, 2: 외부망, 3: DMZ
    uri = `${cmApiPrefix}/objects/addr/${addrObjType}/${addrObjIpVerType}/${zoneType}` // 조회 속도 개선 적용
    const {code, result} = await this.$axios.$get(uri, {loadingShow, loadingHide})
    if (code === 'ok') {
      if (isOkReturn) return result
      if (target !== 'group') commit('getAddressObjDataList', result)
      else commit('cm/objectSecProfile/object/objectSettings/groupObject/parseAddressObjDataList', result, {root: true})
    }
  },
  // 주소 객체 삭제
  async deleteAddressObjData ({commit, dispatch, state, rootState}, {loadingShow = true, loadingHide = true} = {}) {
    const objectType = rootState.cm.objectSecProfile.object.objectSettings.common.objectType
    const addrType = (objectType.indexOf('address.user.ipMapping') > -1 ? 'ipMappingServer' : getAddrObjType(objectType))
    const version = (addrType === 'domain' ? 4 : getAddrVersion(objectType))
    const id = state.selectedData.addr_obj_id
    const url = `${addrType}/${version}/objects/${id}`
    let code = void 0
    let cause = void 0
    try {
      const response = await this.$axios.$delete(`${objApiPrefix}/${url}`, { isReturnError: true, loadingShow, loadingHide })
      code = _.get(response, ['code'])
    } catch (e) {
      code = _.get(e, ['data', 'code'])
      cause = _.get(e, ['data', 'message'])
    }
    if (code === 'ok') {
      commit('deleteAddressObjData', {objectId: id, addrType, rootState})
      dispatch('common/common/setIsChanged', true, {root: true})
      commit('resetAddressObjectData')
    } else if (Number(code) === 15010) { // 삭제 가능
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [],
        forceDelete: [_.assign(selectedData, {cause: cause})]
      }
    } else {
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [_.assign(selectedData, {cause: cause})],
        forceDelete: []
      }
    }
  },
  // 주소 객체 일괄 삭제
  async deleteBatchAddressObjData ({commit, dispatch, state, rootState}, {forceYn = 0} = {}) {
    const url = `objects/multi`
    const id = 'addr_obj_id'
    const selectedData = _.cloneDeep(state.selectedData)
    let addrObjIdList = []
    let multiSelectedData = []
    if (_.get(selectedData, ['length'], 0) > 0) {
      addrObjIdList = _.map(selectedData, item => item[id])
      multiSelectedData = selectedData
    } else {
      addrObjIdList = [selectedData[id]]
      multiSelectedData = [selectedData]
    }
    const params = {
      addr_obj_id_list: addrObjIdList,
      force_yn: forceYn
    }
    const res = await this.$axios.$put(`${cmApiPrefix}/${url}`, params, {successAlert: false})
    if (res.code === 'ok') {
      res.result.can_not_delete = _.get(res.result, ['can_not_delete'], []).map(o => _.assign(o, _.find(multiSelectedData, [id, o[id]])))
      res.result.force_delete_pass = _.get(res.result, ['force_delete_pass'], []).map(o => _.assign(o, _.find(multiSelectedData, [id, o[id]])))
      dispatch('common/common/setIsChanged', true, {root: true})
      commit('resetAddressObjectData')
    }
    return res
  },
  // 주소 객체 저장 (forceYn 0: 중복객체 에러 리턴, 1: 중복객체 중복추가)
  async saveAddressObjData ({commit, dispatch, rootState, state}, {addrType, version, forceYn = 0, loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    let sendData = null
    let url = void 0
    if (addrType === 'host') {
      sendData = state.hostData
      url = 'objects'
      sendData.force_yn = forceYn
      sendData.addr_obj_type = parseAddrObjectTypeNumber(addrType)
      sendData.addr_obj_ip_ver_type = parseAddrObjectIpVersionType(version)
      sendData.addr_obj_desc = _.isUndefined(sendData.addr_obj_desc) ? '' : sendData.addr_obj_desc
    } else if (addrType === 'group') {
      sendData = rootState.cm.objectSecProfile.object.objectSettings.groupObject.addressGroupData
    } else if (addrType === 'network') {
      sendData = computedSetNetworkData(state)
      url = 'objects'
      sendData.force_yn = forceYn
      sendData.addr_obj_ip_ver_type = parseAddrObjectIpVersionType(version)
      sendData.addr_obj_desc = _.isUndefined(sendData.addr_obj_desc) ? '' : sendData.addr_obj_desc
    } else if (addrType === 'domain') {
      sendData = state.domainData
      url = `objects/domain`
      sendData.addr_obj_domain_ip_list = JSON.stringify(state.domainData.fullIpv4)
      sendData.addr_obj_domain_ipv6_list = JSON.stringify(state.domainData.fullIpv6)
      sendData.addr_obj_desc = _.isUndefined(sendData.addr_obj_desc) ? '' : sendData.addr_obj_desc
      if (state.domainData.addr_obj_uname === void 0 || state.domainData.addr_obj_uname === '') {
        state.domainData.addr_obj_uname = state.domainData.domain_name
      }
    }
    const res = await this.$axios.$post(`${cmApiPrefix}/${url}`, sendData, {
      loadingShow,
      loadingHide,
      successAlert
    })

    if (res.code === 'ok') {
      dispatch('common/common/setIsChanged', true, {root: true})
    }
    return res
  },

  // 주소 객체 수정 (forceYn 0: 중복객체 에러 리턴, 1: 중복객체 중복추가)
  async updateAddressObjData ({commit, state, dispatch, rootState}, {addrType, version, loadingShow = true, forceYn = 0, loadingHide = true, successAlert = true} = {}) {
    let sendData = null
    let url = void 0
    if (addrType === 'host') {
      sendData = state.hostData
      url = `objects`
      sendData.force_yn = forceYn
      sendData.addr_obj_desc = _.isUndefined(sendData.addr_obj_desc) ? '' : sendData.addr_obj_desc
    }
    if (addrType === 'network') {
      sendData = computedSetNetworkData(state)
      url = `objects`
      sendData.force_yn = forceYn
      sendData.addr_obj_ip_ver_type = parseAddrObjectIpVersionType(version)
      sendData.addr_obj_id = state.networkData.addr_obj_id
      sendData.addr_obj_desc = _.isUndefined(sendData.addr_obj_desc) ? '' : sendData.addr_obj_desc
    }
    if (addrType === 'domain') {
      sendData = state.domainData
      url = `objects/domain`
      sendData.addr_obj_domain_ip_list = JSON.stringify(state.domainData.fullIpv4)
      sendData.addr_obj_domain_ipv6_list = JSON.stringify(state.domainData.fullIpv6)
      sendData.addr_obj_desc = _.isUndefined(sendData.addr_obj_desc) ? '' : sendData.addr_obj_desc
    }
    if (addrType === 'device') {
      sendData = { dvc_alias: state.deviceData.dvc_alias }
      url = `${addrType}/objects/${state.deviceData.dvc_obj_id}`
    }
    const res = await this.$axios.$put(`${cmApiPrefix}/${url}`, sendData, { loadingShow, loadingHide, successAlert })
    if (res.code === 'ok') {
      dispatch('common/common/setIsChanged', true, {root: true})
    }
    return res
  },
  // 주소 객체 조회
  async getAddressObjData ({commit, state}, {addrType, version, objectId, loadingShow = true, loadingHide = true} = {}) {
    let id = void 0
    let url = void 0
    if (addrType.indexOf('address.user.user') > -1) {
      id = objectId || state.selectedData.usr_obj_id
      url = `user/objects/${id}`
    } else if (addrType === 'address.device.object') {
      id = objectId || state.selectedData.dvc_obj_id
      url = `device/objects/${id}`
    } else if (addrType.indexOf('address.user.ipMapping') > -1) {
      id = objectId || state.selectedData.ip_map_svr_id
      url = `ipmapuser/servers/${id}`
    } else {
      id = objectId || state.selectedData.addr_obj_id
      const
        addrObjId = id, // 주소 객체 아이디, 0 이면 전체 조회
        addrObjType = state.selectedData.addr_obj_type, // 주소 객체 유형, 1 호스트 객체, 2 네트워크 객체 (넷마스크), 3 네트워크 객체 (범위), 4 그룹 객체, 5 도메인 객체, 6 URI 객체 [1,2,3,4,5,6]
        addrObjIpVerType = state.selectedData.addr_obj_ip_ver_type, // 주소 객체 아이피 버전 유형 1 IPv4, 2 IPv6, 3 공통
        zone = state.selectedData.addr_obj_zone_type, // 주소 객체 ZONE 유형 1 내부, 2 외부, 3 DMZ, 0 이면 전체 조회
        pageCnt = 0, // 페이지 당 건수
        pagePos = 0 // 조회 페이지, 시작페이지 0부터
      url = `${cmApiPrefix}/objects/${addrObjId}/${addrObjType}/${addrObjIpVerType}/${zone}/${pageCnt}/${pagePos}`
    }
    const {code, result} = await this.$axios.$get(`${url}`, {loadingShow, loadingHide})
    if (code === 'ok') {
      commit('getAddressObjData', {result, addrType})
    }
  },
  // 주소 객체 조회
  async getLegacyAddressObjData ({commit, state}, {addrType, selectedData, loadingShow = true, loadingHide = true} = {}) {
    const id = selectedData.addr_obj_id
    let url = void 0
    const addrObjId = id, // 주소 객체 아이디, 0 이면 전체 조회
      addrObjType = selectedData.addr_obj_type, // 주소 객체 유형, 1 호스트 객체, 2 네트워크 객체 (넷마스크), 3 네트워크 객체 (범위), 4 그룹 객체, 5 도메인 객체, 6 URI 객체 [1,2,3,4,5,6]
      addrObjIpVerType = selectedData.addr_obj_ip_ver_type, // 주소 객체 아이피 버전 유형 1 IPv4, 2 IPv6, 3 공통
      zone = selectedData.addr_obj_zone_type, // 주소 객체 ZONE 유형 1 내부, 2 외부, 3 DMZ, 0 이면 전체 조회
      pageCnt = 0, // 페이지 당 건수
      pagePos = 0 // 조회 페이지, 시작페이지 0부터
    url = `${cmApiPrefix}/objects/${addrObjId}/${addrObjType}/${addrObjIpVerType}/${zone}/${pageCnt}/${pagePos}`
    const {code, result} = await this.$axios.$get(`${url}`, {loadingShow, loadingHide})
    if (code === 'ok') commit('getAddressObjData', {result, addrType})
  },

  // 방화벽/NAT 설정에서의 주소 객체 저장
  async saveHostObjDataInFirewall (
    {commit, state, rootState, dispatch},
    {
      ip,
      selectObject,
      version,
      ruleType,
      zone,
      loadingShow = true,
      loadingHide = true,
      successAlert = (ruleType !== 'fw-context'),
      currentTabs = 'host',
      // TAMS
      force = 0,
      menu = ''
    } = {}) {
    const globalZone = zone !== void 0 ? zone : rootState.cm.objectSecProfile.object.objectSettings.common.globalZone
    let nameType = void 0,
      data = void 0,
      objectType = void 0,
      autoCreateName = void 0,
      objName = void 0
    if (['fw', 'fw-context'].some(type => type === ruleType)) {
      autoCreateName = Number(version) === 4 ? i18n.t('cmn.firewallRule') : i18n.t('cmn.ipv6FirewallRule')
    } else if (ruleType === 'nat') {
      autoCreateName = i18n.t('cmn.natRule')
    } else if (ruleType === 'portal') {
      autoCreateName = Number(version) === 4 ? i18n.t('cmn.portal') : i18n.t('cmn.ipv6Portal')
    } else if (ruleType === 'appTagging') {
      autoCreateName = Number(version) === 4 ? i18n.t('cmn.appTagging') : i18n.t('cmn.ipv6AppTagging')
    }
    // SSL 정책설정에서 직접입력
    if (state.parentMenu !== '') autoCreateName = state.parentMenu
    if (menu !== '') autoCreateName = menu
    // network object
    const netMask = Number(version) === 4 ? 32 : 128
    if (ip.indexOf('/') > -1 && Number(_.split(ip, '/')[1]) !== netMask) {
      const ipAddr = _.split(ip, '/')[0]
      const netMask = _.split(ip, '/')[1]
      if (globalZone === 1) nameType = 'IN'
      else if (globalZone === 2) nameType = 'EN'
      else nameType = 'DN'
      objectType = 'network'
      objName = `${ipAddr}_${netMask}_${nameType}`
    } else {
      if (ip.indexOf('/') > -1) ip = _.split(ip, '/')[0]
      // host object
      if (globalZone === 1) nameType = 'IH'
      else if (globalZone === 2) nameType = 'EH'
      else nameType = 'DH'
      objectType = 'host'
      objName = `${ip}_${nameType}`
    }
    data = {
      addr_obj_uname: objName,
      addr_obj_desc: i18n.t('cmn.autoCreateRule', {rule: autoCreateName}),
      addr_obj_zone_type: globalZone,
      addr_obj_ip_exp: ip,
      addr_obj_type: parseAddrObjectTypeNumber(objectType),
      addr_obj_ip_ver_type: parseAddrObjectIpVersionType(version),
      force_yn: force
    }
    let res = await this.$axios.$post(`${cmApiPrefix}/objects`, data, { successAlert, loadingHide, loadingShow })
    if (res.code === 'ok') dispatch('common/common/setIsChanged', true, {root: true})
    res = _.assign(res, { objInfo: _.cloneDeep(data) })
    return res
  },

  // AV/DLP 예외 객체 추가시 주소 객체 저장 - @modifier tams_dev2
  async saveExpHostObjData (
    {commit, state, rootState, dispatch},
    {
      ip,
      version,
      ruleType,
      zone,
      loadingShow = true,
      loadingHide = true,
      successAlert = (ruleType !== 'fw-context'),
      currentTabs = 'host',
      force = 0,
      menu = ''
    } = {}) {
    const globalZone = zone !== void 0 ? zone : rootState.cm.objectSecProfile.object.objectSettings.common.globalZone
    let nameType = void 0,
      data = void 0,
      objectType = void 0,
      autoCreateName = void 0,
      objName = void 0
    // SSL 정책설정에서 직접입력
    if (state.parentMenu !== '') autoCreateName = state.parentMenu
    if (menu !== '') autoCreateName = menu
    // network object
    if (ip.indexOf('/') > -1 && Number(_.split(ip, '/')[1]) !== 32) {
      const ipAddr = _.split(ip, '/')[0]
      const netMask = _.split(ip, '/')[1]
      if (globalZone === 1) nameType = 'IN'
      else if (globalZone === 2) nameType = 'EN'
      else nameType = 'DN'
      objectType = 'network'
      objName = `${ipAddr}_${netMask}_${nameType}`
    } else {
      if (ip.indexOf('/') > -1) ip = _.split(ip, '/')[0]
      // host object
      if (globalZone === 1) nameType = 'IH'
      else if (globalZone === 2) nameType = 'EH'
      else nameType = 'DH'
      objectType = 'host'
      objName = `${ip}_${nameType}`
    }
    data = {
      addr_obj_uname: objName,
      addr_obj_desc: i18n.t('cmn.autoCreateRule', {rule: autoCreateName}),
      addr_obj_zone_type: globalZone,
      addr_obj_ip_exp: ip,
      addr_obj_type: parseAddrObjectTypeNumber(objectType),
      addr_obj_ip_ver_type: parseAddrObjectIpVersionType(version),
      force_yn: force
    }
    const res = await this.$axios.$post(`${cmApiPrefix}/objects`, data, {successAlert, loadingHide, loadingShow})
    if (res.code === 'ok') {
      dispatch('common/common/setIsChanged', true, {root: true})
      const saveData = {result: _.assignIn({addr_obj_id: parseInt(res.result.msg, 10)}, _.omit(data, ['force_yn']))}
      return _.assignIn(res, saveData)
    }
    return res
  },
  // DNS Query
  async runDomainDnsQuery ({commit, state}, {loadingHide = true, loadingShow = false} = {}) {
    const domainStr = state.domainData.domain_name
    const url = `${cmApiPrefix}/domain/4/objects/dns-query/${domainStr}`
    const res = await this.$axios.$get(url, {loadingHide, loadingShow})
    if (res.code === 'ok') {
      _.each(res.result.ipv4, (o) => {
        commit('addDomainIpData', {ip: o, ipType: 'ipv4'})
      })
      _.each(res.result.ipv6, (o) => {
        commit('addDomainIpData', {ip: o, ipType: 'ipv6'})
      })
    }
    return res
  },
  // 사용자 객체 - 도메인 조회
  async getUserDomain ({commit}, {loadingShow = true, loadingHide = true} = {}) {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/user/domains`, {loadingShow, loadingHide})
    if (code === 'ok') {
      commit('setUserDomain', result)
      return result
    }
  },
  // 사용자 객체 - IP 매핑 사용자 조회
  async getUserMappingServer ({loadingShow = false, loadingHide = false} = {}) {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/ipmapuser/servers`, {loadingShow, loadingHide})
    if (code === 'ok') {
      return result
    }
  },
  // 사용자 객체 - IP 매핑 서버 조회
  async getIpMappingServer ({commit, state}, {serverType, loadingShow = true, loadingHide = true} = {}) {
    let uri = void 0
    // LDAP
    if (serverType === 1) uri = 'auth/ldap/servers'
    // MS-SQL
    if ([2, 3].includes(serverType)) uri = 'auth/dbms/servers'
    const {code, result} = await this.$axios.$get(`${smApiPrefix}/${uri}`, {loadingShow, loadingHide})
    if (code === 'ok') {
      commit('changeAuthServId', {result, serverType})
      return result
    }
  },
  // 사용자 객체 - 신규 사용자 Import 사용자 목록 조회
  async getIpMappingUserList ({commit, state}, {serverId, loadingShow = true, loadingHide = true} = {}) {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/ipmapuser/servers/${serverId}/import/users`, { loadingShow, loadingHide })
    if (code === 'ok') commit('getIpMappingUserList', result)
  },
  // 사용자 객체 - 신규 사용자 Import 사용자 추가
  async saveIpMappingUser ({commit, state, dispatch, rootState}, {serverId, ruleType, loadingShow = true, loadingHide = true} = {}) {
    let datas = _.filter(state.ipMappingNewUserAllList, o => { return o.use === 1 })
    datas = _.map(datas, o => { return _.pick(o, ['usr_id', 'usr_name', 'usr_depart', 'desc']) })
    const uniqData = _.uniqBy(state.userIpMappingData.mmbr_obj, 'usr_id')
    const {code, result} = await this.$axios.$post(`${objApiPrefix}/ipmapuser/servers/${serverId}/users`, {mmbr_obj: datas}, { loadingShow, loadingHide })
    if (code === 'ok') {
      dispatch('common/common/setIsChanged', true, {root: true})
      if (ruleType === 'fw') commit('saveFwIpMappingUser', {result, uniqData})
      else commit('saveIpMappingUser', result)
    }
  },
  // IP 매핑 사용자 - 사용자 조회
  async getIpMappingUserData ({commit, state}, {serverId, loadingShow = true, loadingHide = true} = {}) {
    const userId = state.selectedData.ip_map_usr_id
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/ipmapuser/servers/${serverId}/users/${userId}`, { loadingShow, loadingHide })
    if (code === 'ok') { return result }
  },
  // 사용자 객체 - IP 매핑 사용자 설명 데이터 수정
  async updateIpMappingUserData ({commit, state}, {serverId, ipMappingUserData, loadingShow = true, loadingHide = true} = {}) {
    const userId = state.selectedData.ip_map_usr_id
    const {code, result} = await this.$axios.$put(`${objApiPrefix}/ipmapuser/servers/${serverId}/users/${userId}`, {
      desc: ipMappingUserData.desc
    }, {loadingShow, loadingHide})
    if (code === 'ok') commit('updateIpMappingUserData', result)
  },
  // 주소 객체 참조 여부 상세 조회
  // TAMS 제외 (미사용, TAMS 전용 통합 API를 통해 참조 여부 조회)
  async getAddressDetailRefData ({commit, state, rootState}, {objectData, objectType, version, loadingShow = true, loadingHide = true} = {}) {
    let objId = void 0
    let url = void 0
    if (['host', 'network', 'domain'].includes(objectType)) {
      objId = objectData.addr_obj_id
      url = `${objectType}/${version}/objects`
    }
    if (objectType === 'user') {
      objId = objectData.usr_obj_id
      url = `user/objects`
    }
    if (objectType === 'device') {
      objId = objectData.dvc_obj_id
      url = `device/objects`
    }
    if (objectType === 'ipMapping') {
      objId = objectData.ip_map_usr_id
      url = `ipmapuser/servers/${objectData.ip_map_svr_id}/users`
    }
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/${url}/${objId}/ref`, {loadingShow, loadingHide})
    if (code === 'ok') commit('cm/objectSecProfile/object/objectSettings/common/setUsedDetailData', result, {root: true})
  },
  async getDeviceInfo ({commit, state}, {objectId, loadingShow = true, loadingHide = true} = {}) {
    if (!objectId) return {}
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/device/objects/${objectId}/info`, {
      loadingShow,
      loadingHide
    })
    if (code === 'ok') {
      commit('setDeviceInfo', result)
    }
  }
}
export const getters = {}
export const strict = false
